// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_dedicated_dc from '../../img/icons/24/color/dedicated_dc.svg';
import Icon_shared_dc from '../../img/icons/24/color/shared_dc.svg';
import Icon_isp from '../../img/icons/24/color/isp.svg';
import Icon_isp_plus from '../../img/icons/24/color/isp_premium.svg';
import Icon_smart_resi from '../../img/icons/24/color/residential.svg';
import Icon_tickets from '../../img/icons/24/color/events_resi.svg';
import Icon_sneakers from '../../img/icons/24/color/sneakers.svg';
import Icon_ecommerce from '../../img/icons/24/color/events_and_ecommerce.svg';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import {Button, t_oculus_button_props} from '../../lib/button';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {useHistory} from 'react-router-dom';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {oculus_proxy_type} from '../../types';
import {product_pages} from '../products';
import styles from './products.module.less';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';

type t_variant = 'info' | 'pricing';

interface i_product_info {
    title: string;
    text: string;
    icon: JSX.Element;
    btn: t_oculus_button_props;
}

const arrow = <Icon_arrow_right width={16} height={16}/>;

const products_info =
(show_promo: boolean): Record<oculus_proxy_type, i_product_info>=>({
    [Proxy_type.SDC]: {
        title: 'Shared Datacenter Proxies',
        text: 'Cost-efficient proxies offering reliable performance.',
        icon: <Icon_shared_dc/>,
        btn: {
            caption:
                <>{show_promo ? 'Free trial':
                  'Starts from $0.1/GB'} {arrow}</>,
            to: '/pricing/shared-datacenter-proxies',
            color: show_promo ? 'primary' : 'secondary',
        },
    },
    [Proxy_type.DDC]: {
        title: 'Dedicated Datacenter Proxies',
        text: 'Premium, exclusive proxies delivering top-tier speed and '
            +'privacy.',
        icon: <Icon_dedicated_dc/>,
        btn: {
            caption: <>Starts from $0.50/IP {arrow}</>,
            to: '/pricing/dedicated-datacenter-proxies',
        },
    },
    [Proxy_type.SHARED_ISP]: {
        title: 'ISP Proxies',
        text: 'Global IPs for access to any site, except social media & '
            +'search engines.',
        icon: <Icon_isp />,
        btn: {
            caption: <>Starts from $0.50/GB {arrow}</>,
            to: '/pricing/shared-isp-proxies',
        },
    },
    [Proxy_type.ISPPREM]: {
        title: 'ISP Premium Proxies',
        text: 'US-based IPs for accessing search engines and social media.',
        icon: <Icon_isp_plus />,
        btn: {
            caption: <>Starts from $0.75/IP {arrow}</>,
            to: '/pricing/isp-premium-proxies',
        },
    },
    [Proxy_type.RES]: {
        title: 'Rotating Residential Proxies',
        text: 'Read-only IPs for smooth and consistent data access.',
        icon: <Icon_smart_resi />,
        btn: {
            caption: <>Starts from $1/GB {arrow}</>,
            to: '/pricing/smart-residential-proxies',
        },
    },
    [Proxy_type.EV_ISP]: {
        title: 'Events & E-commerce Proxies',
        text: `Ideal for top event spots and smooth
            e-commerce access.`,
        icon: <Icon_ecommerce />,
        btn: {
            caption: <>Starts from $0.57/IP {arrow}</>,
            to: '/pricing/isp-event-ecommerce-proxies',
        },
    },
    [Proxy_type.EV_RES]: {
        title: 'Tickets Residential Proxies',
        text: 'Full access to leading ticket sites, requiring a quick identity'
            + 'verification process!',
        icon: <Icon_tickets/>,
        btn: {
            caption: <>Starts from $0.68/GB {arrow}</>,
            to: '/pricing/events-tickets-residential-proxies',
        },
    },
    [Proxy_type.SNK]: {
        title: 'Sneakers Residential Proxies',
        text: 'Full access to top sneaker sites without identity verification '
            +' process!',
        icon: <Icon_sneakers />,
        btn: {
            caption: <>Starts from $0.85/GB {arrow}</>,
            to: '/pricing/sneakers-residential-proxies',
        },
    },
    [Proxy_type.SCR]: {
        title: 'Proxies',
        text: `Ideal for top event spots.`,
        icon: <Icon_dedicated_dc />,
        btn: {
            caption: <>Starts from $0.64/GB {arrow}</>,
            to: '/pricing/dedicated-datacenter-proxies',
        },
    },
    [Proxy_type.UNKNOWN]: {
        title: 'Proxies',
        text: `Ideal for top event spots.`,
        icon: <Icon_dedicated_dc />,
        btn: {
            caption: <>Starts from $0.64/GB {arrow}</>,
            to: '/pricing/dedicated-datacenter-proxies',
        },
    },
});

interface i_product_card_props {
    product: oculus_proxy_type;
    variant: t_variant;
}
export const Product_card = (props: i_product_card_props)=>{
    const {product, variant} = props;
    const history = useHistory();
    const {theme} = use_theme({def: 'oculus'});
    const {show_free_zone_promo} = use_app_context();
    const card_cls = cn(styles.product_card, styles[product], styles[variant]);
    const p = products_info(show_free_zone_promo)[product];
    return <div className={card_cls}
      onClick={()=>{
        if (variant=='info')
          history.push(product_pages[product]);
        if (variant=='pricing')
          history.push(p.btn.to);
      }}>
      <div className={styles.img}>{p.icon}</div>
      <div className={styles.content}>
      <a href={variant == 'pricing' ? get_new_link(p.btn.to) :
        get_new_link(product_pages[product])}
        className={cn(theme.P, theme.p14, theme.bold, styles.title)}>{p.title}
      </a>
        {variant=='info' && <p className={cn(theme.p12, theme.med, styles.pt)}>
          {p.text}</p>}
        {variant=='pricing' && <Button size="xs" color="secondary"
          cls={styles.pricing_btn} {...p.btn}/>}
      </div>
    </div>;
};

interface i_products_menu_props {
    variant: 'info' | 'pricing';
}
export const Products_menu = (props: i_products_menu_props)=>{
    const {variant} = props;
    const {theme} = use_theme({def: 'oculus'});
    return <div className={styles.products_menu}>
      <div className={styles.group}>
        <p className={cn(styles.group_title, theme.p14, theme.med)}>ISP
          Proxies</p>
        <div className={styles.items}>
          <Product_card variant={variant} product={Proxy_type.SHARED_ISP}/>
          <Product_card variant={variant} product={Proxy_type.ISPPREM}/>
          <Product_card variant={variant} product={Proxy_type.EV_ISP}/>
        </div>
      </div>
      <div className={styles.group_separator}/>
      <div className={styles.group}>
        <p className={cn(styles.group_title, theme.p14, theme.med)}>Datacenter
          Proxies</p>
        <div className={styles.items}>
          <Product_card variant={variant} product={Proxy_type.SDC}/>
          <Product_card variant={variant} product={Proxy_type.DDC}/>
        </div>
      </div>
      <div className={styles.group_separator}/>
      <div className={styles.group}>
        <p className={cn(styles.group_title, theme.p14, theme.med)}>Residential
          Proxies</p>
        <div className={styles.items}>
          <Product_card variant={variant} product={Proxy_type.RES}/>
          <Product_card variant={variant} product={Proxy_type.SNK}/>
          <Product_card variant={variant} product={Proxy_type.EV_RES}/>
        </div>
      </div>
    </div>;
};
